// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__31yS5","tab":"ProcedureTabs_tab__3eWlQ"};